module.exports = __webpack_public_path__ + "media/images/iconDown__accent--dark-cfc30c07c62d6129369e02996943ae05.png";